<template>
  <div  class="content-wrapper">
    <el-form label-width="160px" label-position="right" class="demo-dynamic">
      <el-form-item label="下发幼儿园：" prop="gardenId">
          <el-select v-model="gardenId" placeholder="请选择下发幼儿园" style="width:230px">
              <el-option v-for="item in selectGarden" :key="item.kindOrgID" :label="item.kindOrgName" :value="item.kindOrgID"></el-option>
          </el-select>
      </el-form-item>
      <div class="warningTip">
        <span>温馨提示：下发匹配成功后，将无法修改下发幼儿园！</span>
      </div>
    </el-form>
    <div style="text-align:center;">
      <el-button class="btn-primary" type="primary" style="margin-top:20px;" size='small' @click='confirmModule()'>确定</el-button>
      <el-button type="normal" style="margin-top:20px;" size='small' @click="cancel()">取消</el-button>
    </div>
  </div>
</template>

<script>
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
export default {
  data () {
    return {
      row:'',
      gardenId:'',
      selectGarden: []
    }
  },
  methods: {
    confirmModule () {
      var self = this
      if(self.gardenId == '') {
        self.$message({ message: "请选择下发的幼儿园", type: 'warning'})
      } else {
        var nparm = {
          'mecInfoIds': self.row.id,
          gardenId: self.gardenId
        }
        api.post(config.host + 'childMec/updateBatchInfoIsUseState.do', nparm).then(function (response) {
          if (response.success === true) {
             self.cancel()
             var data = [response.body.errStr]
             data.push.apply(data, response.body.errStrList)
             self.$emit('openMsgBox',data, true, true);
          }
        })
      }
    },
    cancel () { // 下发的取消按钮
      this.$emit('close');
    }
  },
  created() {
     this.row = this.$route.query.list;
     var self = this;
     var param = {};
     param.name = this.row.childName
     param.sex = this.row.sex
     param.birthday = this.row.birthday
     api.post(config.host + 'child/kind/getMatchedChildListForSecond.do', param).then(function (response) {
        if (response.success === true) {
          self.selectGarden = response.body
        }
      })
  }
}
</script>
<style scoped>
.warningTip {
    color: #e6a23c;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/physical/issued.vue